export default __webpack_public_path__ + "static/media/1837.870d826f.png";